"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditSingleObjective = void 0;
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const useEditSingleObjective = (objectiveId) => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectivesClient_1.editObjective)(objectiveId, body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    });
};
exports.useEditSingleObjective = useEditSingleObjective;
